import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserRole } from '../enums/user-role.enum';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'roleName',
})
export class RoleNamePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(role: UserRole): string {
        switch (role) {
            case UserRole.client:
                return this.translateService.instant('client');
            case UserRole.admin:
                return this.translateService.instant('admin');
            case UserRole.manager:
                return this.translateService.instant('manager');
            case UserRole.staff:
                return this.translateService.instant('agent');
            case UserRole.vendor:
                return this.translateService.instant('vendor');
            case UserRole.readOnlyUser:
                return this.translateService.instant('read only user');
            default:
                return this.translateService.instant('unknown role');
        }
    }
}
